/**
 * SNS Links Panel (V2)
 *
 * Setup layer: initialization and module integration.
 */

import { Roles } from "../../constants/roles";
import { SNSLinksPanelForm } from "./sns-links-panel-form";
import { SNSLinksPanelHandler } from "./sns-links-panel-handler";
import { SNSLinksPanelListener } from "./sns-links-panel-listener";

export class SNSLinksPanelSetup {
    private readonly root: HTMLElement;
    private readonly form: SNSLinksPanelForm;
    private readonly handler: SNSLinksPanelHandler;
    private readonly listener: SNSLinksPanelListener;

    /** Build the panel collaborators for a given root. */
    public constructor(root: HTMLElement) {
        this.root = root;
        this.form = new SNSLinksPanelForm(root);
        this.handler = new SNSLinksPanelHandler(this.form);
        this.listener = new SNSLinksPanelListener(this.form, this.handler);
    }

    public init(): void {
        this.listener.register();
    }

    /** Initialize one panel root or scan a parent container for panels. */
    public static init(rootEl: HTMLElement | ParentNode | Document | null | undefined): void {
        if (rootEl instanceof HTMLElement && rootEl.getAttribute("data-role") === Roles.SNS_LINKS_PANEL) {
            if (rootEl.dataset.snsLinksPanelInit === "1") {
                return;
            }

            rootEl.dataset.snsLinksPanelInit = "1";
            const instance = new SNSLinksPanelSetup(rootEl);
            instance.init();
            return;
        }

        const root = rootEl || document;
        SNSLinksPanelForm.getPanelRoots(root).forEach((node) => {
            if (!(node instanceof HTMLElement)) {
                return;
            }

            if (node.dataset.snsLinksPanelInit === "1") {
                return;
            }

            node.dataset.snsLinksPanelInit = "1";
            const instance = new SNSLinksPanelSetup(node);
            instance.init();
        });
    }
}
